import React from 'react';

const PrintStudentInfo = ({ etudiant, classe, bulletin }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  const getInscriptionInfo = () => {
    if (bulletin?.informations_inscription) {
      return bulletin.informations_inscription;
    }
    return null;
  };

  const inscriptionInfo = getInscriptionInfo();

  return (
    <div className="student-info" style={{ marginBottom: '6px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        {/* Informations de l'étudiant */}
        <div style={{ 
          border: '1px solid #000', 
          padding: '6px',
          backgroundColor: '#fafafa'
        }}>
          <h3 style={{ 
            fontSize: '9px', 
            fontWeight: 'bold', 
            margin: '0 0 4px 0',
            borderBottom: '1px solid #000', 
            paddingBottom: '2px',
            textTransform: 'uppercase',
            letterSpacing: '0.3px'
          }}>
            Informations de l'étudiant
          </h3>
          <div style={{ fontSize: '8pt', lineHeight: '1.3' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Nom et Prénoms:</span>
              <span style={{ fontWeight: '500' }}>
                {etudiant ? `${etudiant.nom} ${etudiant.prenom}` : 'N/A'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}># Matricule:</span>
              <span style={{ fontWeight: '500' }}>
                {etudiant?.matricule || 'Non attribué'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Date de naissance:</span>
              <span style={{ fontWeight: '500' }}>
                {etudiant?.date_naissance ? formatDate(etudiant.date_naissance) : 'Non renseignée'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Lieu de naissance:</span>
              <span style={{ fontWeight: '500' }}>
                {etudiant?.lieu_naissance || 'Non renseigné'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Genre:</span>
              <span style={{ fontWeight: '500' }}>
                {etudiant?.genre || 'Non renseigné'}
              </span>
            </div>
            {etudiant?.email && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                <span style={{ fontWeight: '600' }}>Email:</span>
                <span style={{ fontWeight: '500' }}>
                  {etudiant.email}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Informations académiques et de classe */}
        <div style={{ 
          border: '1px solid #000', 
          padding: '6px',
          backgroundColor: '#fafafa'
        }}>
          <h3 style={{ 
            fontSize: '9px', 
            fontWeight: 'bold', 
            margin: '0 0 4px 0',
            borderBottom: '1px solid #000', 
            paddingBottom: '2px',
            textTransform: 'uppercase',
            letterSpacing: '0.3px'
          }}>
            Informations académiques
          </h3>
          <div style={{ fontSize: '8pt', lineHeight: '1.3' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Classe actuelle:</span>
              <span style={{ fontWeight: '500' }}>
                {classe?.libelle || 'Non définie'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Niveau:</span>
              <span style={{ fontWeight: '500' }}>
                {classe?.niveau?.libelle || inscriptionInfo?.niveau || 'Non défini'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Filière:</span>
              <span style={{ fontWeight: '500' }}>
                {inscriptionInfo?.filiere || 'Non définie'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Effectif de classe:</span>
              <span style={{ fontWeight: '500' }}>
                {bulletin?.moyenne_semestre?.effectif_classe || 'N/A'} étudiants
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Date d'inscription:</span>
              <span style={{ fontWeight: '500' }}>
                {inscriptionInfo?.date_inscription ? formatDate(inscriptionInfo.date_inscription) : 'Non renseignée'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ fontWeight: '600' }}>Date d'édition:</span>
              <span style={{ fontWeight: '500' }}>
                {bulletin?.date_generation ? formatDate(bulletin.date_generation) : 'N/A'}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Note d'information sur les données manquantes - SUPPRIMÉE */}
    </div>
  );
};

export default PrintStudentInfo;
